import { useSelector } from "react-redux";
import { Card } from "react-bootstrap";
import { RootState } from "@reducers/rootReducer";
import FeaturesList from "../common/FeaturesList";
import ComingSoon from "../common/ComingSoon";
import useGetAccount from "../api/useGetAccount";
import {
  useListUserFlagValuesQuery,
  useUpdateUserFlagValueMutation,
} from "../../../../services/ScopeStackAPI";

const Features = (): JSX.Element => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);
  const { data: flags, isLoading } = useListUserFlagValuesQuery();
  const { data: account } = useGetAccount(accountSlug);
  const [updateUserFlagValue] = useUpdateUserFlagValueMutation();

  return (
    <>
      <Card className="whiteBg">
        <Card.Header className="headerOverride">Preferences</Card.Header>
        <hr className="cardHeadDivider" />
        <Card.Body className="whiteBg">
          <FeaturesList
            flags={flags}
            isLoading={isLoading}
            onUpdate={(id, variation) => updateUserFlagValue({ id, variation })}
            shortDateFormat={account?.attributes?.shortDateFormat}
          />
        </Card.Body>
      </Card>
      <ComingSoon />
    </>
  );
};

export default Features;
